import { useState, useEffect, useLayoutEffect } from 'react';
import { queryObjectToString, noop } from './utilities';

export const mockMediaQueryList = {
  media: '',
  matches: false,
  onchange: noop,
  addListener: noop,
  removeListener: noop,
  addEventListener: noop,
  removeEventListener: noop,
  dispatchEvent: () => true,
};
const createUseMedia = effect => (rawQuery, defaultState = false) => {
  const [state, setState] = useState(defaultState);
  const query = queryObjectToString(rawQuery);
  effect(() => {
    let mounted = true;
    const mediaQueryList = typeof window === 'undefined' ? mockMediaQueryList : window.matchMedia(query);
    const onChange = () => {
      if (!mounted) {
        return;
      }
      setState(Boolean(mediaQueryList.matches));
    };
    if (mediaQueryList.addEventListener) {
      mediaQueryList.addEventListener('change', onChange);
    } else {
      mediaQueryList.addListener(onChange);
    }
    setState(mediaQueryList.matches);
    return () => {
      mounted = false;
      if (mediaQueryList.removeEventListener) {
        mediaQueryList.removeEventListener('change', onChange);
      } else {
        mediaQueryList.removeListener(onChange);
      }
    };
  }, [query]);
  return state;
};
export const useMedia = createUseMedia(useEffect);
export const useMediaLayout = createUseMedia(useLayoutEffect);
export default useMedia;
